import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./components/Home";
import Chat from "./components/Chat";
import Login from "./components/Login";
import Callback from "./components/Callback";
import Admin from "./components/Admin";
import AdminLogin from "./components/AdminLogin";
import Legal from "./components/Legal";
import Investors from "./components/Investors";
import Blog from "./components/Blog";
import BlogList from "./components/BlogList";
import BlogPostView from "./components/BlogPostView";
import BlogAdmin from "./components/BlogAdmin";
import FoundingDayStory from "./components/FoundingDayStory";
import CompanyStory from "./components/CompanyStory";
import InvestmentOpportunity from "./components/InvestmentOpportunity";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/callback" element={<Callback />} />
            <Route path="/chat" element={<Navigate to="/?chat=open" replace />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/investors" element={<Investors />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPostView />} />
            <Route path="/blog-admin" element={<BlogAdmin />} />
            <Route path="/blog-old" element={<Blog />} />
            <Route path="/blog/founding-day" element={<FoundingDayStory />} />
            <Route path="/blog/company" element={<CompanyStory />} />
            <Route path="/blog/investment" element={<InvestmentOpportunity />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/story" element={<FoundingDayStory />} />
            <Route path="/invest" element={<InvestmentOpportunity />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;